import AppPage from 'src/components/AppPage';
import InventoryTable from './InventoryTable';

const MainInventory = () => (
  <AppPage
    title="Template Inventory"
    heading="Template inventory"
    description="Starter product lists that shops can import when they set up their inventory."
  >
    <InventoryTable />
  </AppPage>
);

export default MainInventory;
